export default "__VITE_ASSET__c662cc7d__"